export enum PathsEnum {
	LOGIN = '/login',
	NONE = '/',
	COLABORADOR = '/colaborador',
	HOLERITE = '/colaborador/holerite',
	BANCODEHORAS = '/colaborador/banco-horas',
	INFORMERENDIMENTOS = '/colaborador/informe-rendimentos',
	BENEFICIOS = '/colaborador/beneficios',
	ALIMENTACAO = '/colaborador/beneficios/alimentacao',
	TRANSPORTE = '/colaborador/beneficios/transporte',
	SAUDE = '/colaborador/beneficios/saude',
	FERIAS = '/colaborador/ferias',
	DETALHESPERIODO = '/colaborador/ferias/detalhes-periodo/:inicioPeriodo/:fimPeriodo',
	DETALHESFERIAS = '/colaborador/ferias/detalhes-ferias/:inicioPeriodo/:inicioFerias/:diasProgramados/:diasAbono/:adiantamento13/:descricaoStatus',
	VAREJO = '/varejo',
	PERFORMANCE_PRODUTO = '/varejo/performance-produto',
	VAREJO_PRODUTO_IMAGEM = '/varejo/produto/busca-imagem',
}
